import { Component, Input } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../../../interviews.models";

@Component({
    selector: 'interview-dashboard-card-cancelled',
    templateUrl: './interview-dashboard-card-cancelled.component.html',
    standalone: false
})
export class InterviewDashboardCardCancelledComponent {
  @Input() meeting?: CandidateMeetingModel;
  @Input() dashboardInfo: InterviewDashboardResult | null = null;
}
